import type { RefObject } from "react";
import type { BaseLayerId, MeasurementResult } from "../editorTypes";
import BaseLayerSwitcher from "./BaseLayerSwitcher";

interface MapCanvasProps {
  mapDivRef: RefObject<HTMLDivElement | null>;
  baseLayer: BaseLayerId;
  onBaseLayerChange: (id: BaseLayerId) => void;
  measurement: MeasurementResult | null;
}

export default function MapCanvas({ mapDivRef, baseLayer, onBaseLayerChange, measurement }: MapCanvasProps) {
  return (
    <div className="relative flex-1 min-w-0 h-full bg-background-100">
      <div ref={mapDivRef} className="absolute inset-0" />
      <BaseLayerSwitcher active={baseLayer} onChange={onBaseLayerChange} />
      {measurement && (
        <div className="absolute top-3 right-3 z-10 bg-white/95 backdrop-blur rounded-lg shadow-md border border-background-200/70 px-3 py-2 text-sm">
          <span className="text-foreground-500">{measurement.type === "distance" ? "Distância: " : "Área: "}</span>
          <span className="font-semibold text-foreground-900">{measurement.label}</span>
        </div>
      )}
    </div>
  );
}
